import React from 'react';

export default function RRHHNativeShell({ title, subtitle, actions, children, className = '' }) {
  return (
    <div className={`rrhh-native-page ${className}`.trim()}>
      <header className="page-header rrhh-native-header">
        <div>
          <h1 className="page-title">{title}</h1>
          {subtitle && <p className="page-subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="rrhh-native-actions">{actions}</div>}
      </header>
      {children}
    </div>
  );
}
